import React from "react";

import { BulletList, BulletListType } from "@at/design-system-patterns";

import * as Styled from "../leasing-modal-shared-styles.styled";

export const WhatYouGetModal = () => {
  return (
    <Styled.Content>
      <Styled.Title as="h3" weight="400">
        What you get when you lease with Auto Trader
      </Styled.Title>
      <Styled.Body>
        <p>
          These are the extra bits you need to know about what comes with your
          Auto Trader lease agreement.
        </p>
        <Styled.Subheading>Free returns within 30 days</Styled.Subheading>
        <p>
          If you decide your new lease vehicle isn’t for you, you can return it
          for free and we’ll collect it from your home address.
        </p>
        <p>
          However, please be aware that you can only return your car for free
          if:
        </p>
        <BulletList
          items={[
            "It has not been driven more than 50 miles",
            "It has not been damaged",
          ]}
          listType={BulletListType.STANDARD}
        />
        <Styled.HighlightedPoint>
          <p>
            <Styled.HighlightedText>
              Important to remember:
            </Styled.HighlightedText>{" "}
            You can only return your lease vehicle for free if you have driven
            it for less than 50 miles (above what was already stated on the
            mileage clock when the car was delivered).{" "}
          </p>
          <p>The car must also not have any damage.</p>
        </Styled.HighlightedPoint>
        <Styled.Subheading>Road tax included</Styled.Subheading>
        <p>
          When you buy a vehicle, rather than lease it, you need to arrange road
          tax yourself by contacting the DVLA.
        </p>
        <p>
          But when you lease with us, we’ll organise your road tax for you. The
          cost is built into your monthly lease payments, so you only pay one
          easy amount.
        </p>
        <Styled.HighlightedPoint>
          <p>
            <Styled.HighlightedText>Good to know:</Styled.HighlightedText>{" "}
            Sometimes the government may raise or lower the ‘Road Fund Licence’
            (RFL), which affects how much road tax costs, partway through your
            lease agreement.{" "}
          </p>
          <p>
            If this happens, you may need to pay a little extra (or you may get
            some money back if the RFL goes down).{" "}
          </p>
        </Styled.HighlightedPoint>
        <Styled.Subheading>Roadside assistance included</Styled.Subheading>
        <p>
          An added bonus to make driving your brand-new lease vehicle even
          smoother.
        </p>
        <p>
          Your lease vehicle will come with free roadside assistance included,
          which is provided by the manufacturer of the vehicle.
        </p>
        <Styled.HighlightedPoint as="p">
          <Styled.HighlightedText>Good to know:</Styled.HighlightedText> The
          amount of cover you get may vary between manufacturers. The majority
          offer a minimum of three years roadside assistance, but you can ask a
          member of our team for the exact amount of cover you will get for your
          car.
        </Styled.HighlightedPoint>
        Want to know more?{" "}
        <a
          href="https://www.autotrader.co.uk/terms-and-conditions/vanarama"
          target="_blank"
          rel="noreferrer"
        >
          Read our full Terms and Conditions
        </a>{" "}
        for all the legal bits.
      </Styled.Body>
    </Styled.Content>
  );
};
